import { render, staticRenderFns } from "./ReportGeneralPane.vue?vue&type=template&id=58392db2&"
import script from "./ReportGeneralPane.vue?vue&type=script&lang=ts&"
export * from "./ReportGeneralPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports